import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Icon, Button, Dropdown} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../common/actions';
import './boxSearch.scss';

class BoxSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'boxSelected': '',
    };
  }

  fetchData() {
    const {invoice} = this.props;
    this.props.fetchBoxesByInvoice(invoice);
    this.setState({'modalWasOpen': true});
  }

  getBoxes() {
    return this.props.listBoxes.map((item) => {
      return {'text': item.box, 'value': item.box};
    });
  }

  boxesSearch = (options, query) => {
    const {partLength} = this.props;

    const inputText = query.toUpperCase().substring(0, partLength);

    const regex = new RegExp(_.escapeRegExp(inputText));
    return options.filter((opt) => regex.test(opt.text));
  }

  updateBoxSelected(value) {
    this.setState({'boxSelected': value});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }
  
  onCloseStorageCarClick() {
    const {invoice, index} = this.props;
    const {boxSelected} = this.state;
    this.props.setLastCheckedBox(index, boxSelected);
    this.props.validateBoxBelongInvoice(invoice, boxSelected, index);
    this.onCloseModalClick();
  }

  render() {
    const {modalWasOpen, boxSelected} = this.state;
    const {invoice, loading, saving, itemSaved} = this.props;

    if (itemSaved) {
      return <div />;
    }
    if (saving) {
      return <Icon name='search' size='large' color='blue' />;
    }
    return (
      <Modal size='tiny' onOpen={() => this.fetchData()}
        className='binning-search-boxes'
        open={modalWasOpen}
        trigger={
          <Icon name='search' size='large' color='blue' />
        }>
        <Modal.Header>
          Listado de cajas de la factura {invoice}
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
             
            <Dropdown selection
              options={this.getBoxes()}
              search={this.boxesSearch.bind(this)}
              searchInput={{'autoFocus': true}}
              disabled={loading}
              loading={loading}
              defaultOpen
              onChange={(e, {value}) => this.updateBoxSelected(value)}
              placeholder='Seleccione una caja'
              noResultsMessage='Caja no pertenece a la factura'
            />

          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => this.onCloseModalClick()}>
            Cancelar
          </Button>
          <Button positive
            disabled={!boxSelected}
            onClick={() => this.onCloseStorageCarClick()}>
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.checking.loadingBoxes,
    'listBoxes': state.checking.listBoxes,
  };
};

const {
  fetchBoxesByInvoice,
  setLastCheckedBox,
  validateBoxBelongInvoice,
} = Actions;

export default connect(mapStateToProps, {
  fetchBoxesByInvoice,
  setLastCheckedBox,
  validateBoxBelongInvoice,
})(BoxSearchModal);
